export const customTheme = {
  textcolor: {
    primary: {
      on: '#FF124F',
      off: '#FF72CA',
    },
    secondary: {
      on: '#3d43b4',
      off: '#8386f5',
    },
  },
  bordercolor: {
    primary: {
      on: '#FF124F',
      off: '#FF72CA',
      blur: '#FF00A0',
    },
    secondary: {
      on: '#3d43b4',
      off: '#8386f5',
      blur: '#3d43b4',
    },
  },
  fontFamily: {
    name: 'monoton',
  },
};
